module.exports = __webpack_public_path__ + "static/vidplaybutton-9a97acfe5e0ebcaf3c022c7f27d6dcd7.png";